import { render, staticRenderFns } from "./ContextSwitchOverlay.vue?vue&type=template&id=5f3a0aa2&scoped=true&"
import script from "./ContextSwitchOverlay.vue?vue&type=script&lang=js&"
export * from "./ContextSwitchOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ContextSwitchOverlay.vue?vue&type=style&index=0&id=5f3a0aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3a0aa2",
  null
  
)

export default component.exports